$(document).ready(function () {

  // ─── Lazy load spinner ────────────────────────────────────────────────────
  var lastScrollTop = 0;

  var spinnerTimeout = setInterval(function () {
    if ($(".brands-load-icon").length > 0) {
      $(".brands-load-icon").removeClass("brands-load-iconing");
      clearInterval(spinnerTimeout);
    }
  }, 600);

  function lazyLoadIcons() {
    $(".brand-lazy-load-icon img:not(.brand-loaded)").each(function () {
      var img = $(this);
      if (isElementInView(img) && !img.hasClass("brand-loaded")) {
        img.closest(".brands-load-icon").addClass("brands-load-iconing");
        setTimeout(function () {
          img.attr("src", img.data("src")).addClass("brand-loaded");
          img.closest(".brands-load-icon").removeClass("brands-load-iconing");
        }, 600);
      }
    });
  }

  function isElementInView(element) {
    var wTop    = $(window).scrollTop();
    var wBottom = wTop + $(window).height();
    var eTop    = element.offset().top;
    var eBottom = eTop + element.height();
    return eBottom >= wTop && eTop <= wBottom;
  }

  lazyLoadIcons();

  $(window).on("scroll", function () {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) lazyLoadIcons();
    lastScrollTop = st;
  });


  // ─── Search + Filter ──────────────────────────────────────────────────────

  var activeFilter = 'all';
  var debounce;

  function applyFilters(query) {
    var q         = (query || '').toLowerCase().trim();
    var $allItems = $('#all_brands_grid .brand-grid-item');
    var found     = false;

    $allItems.each(function () {
      var $item = $(this);

      // use data-title for search — clean collection title only
      var title = ($item.attr('data-title') || '').toLowerCase();

      // Tag filter check
      var tagMatch = true;
      if (activeFilter !== 'all') {
        var tags = ($item.attr('data-tags') || '').trim().split(' ');
        tagMatch = tags.indexOf(activeFilter) !== -1;
      }

      // Search check against data-title
      // var searchMatch = (q === '') ? true : (title.indexOf(q) !== -1);
      var searchMatch = (q === '') ? true : matchesCompactSearch(title, q);

      if (tagMatch && searchMatch) {
        $item.show();
        found = true;
      } else {
        $item.hide();
      }
    });

    // No results message — toggle visibility
    if (!found && $allItems.length > 0) {
      $('#brands-no-results').show();
    } else {
      $('#brands-no-results').hide();
    }

    lazyLoadIcons();
  }

  // Search input — show/hide close button based on value
  $(document).on('input', '.brand-search-box', function () {
    clearTimeout(debounce);
    var query = $(this).val();
    $('.icon-close').toggle(query.length > 0);
    debounce = setTimeout(function () {
      applyFilters(query);
    }, 200);
  });

  // Close/reset button — clear input, hide itself, show all brands
  $(document).on('click', '.icon-close', function () {
    $('.brand-search-box').val('');
    $(this).hide();
    applyFilters('');
  });

  // Tag filter buttons
  $(document).on('click', '.brand-filter-btn', function () {
    $('.brand-filter-btn').removeClass('active');
    $(this).addClass('active');
    activeFilter = $(this).data('filter').toString();
    applyFilters($('.brand-search-box').val());
  });

  // Hide close button on init
  $('.icon-close').hide();

});
